"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformModelTokenApi = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
/**
 * Operations for creating tokens for models on Geometry Backend Systems
 */
class SdPlatformModelTokenApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "tokens";
    }
    /**
     * Get a token for interacting with a model on its geometry backend system.
     * @param body {@link SdPlatformRequestModelTokenCreate} body of a request.
     * @returns token for accessing one or several models on a ShapeDiver Geometry Backend system
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.TokenCreate, body);
    }
}
exports.SdPlatformModelTokenApi = SdPlatformModelTokenApi;
//# sourceMappingURL=SdPlatformModelTokenApi.js.map